import { render, staticRenderFns } from "./PartnerCompany.vue?vue&type=template&id=2927d6ae"
import script from "./PartnerCompany.vue?vue&type=script&lang=js"
export * from "./PartnerCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports